// Project Imports
import DashboardResource from 'core/resources/Dashboard';

const resources = [DashboardResource];

export default resources;
